import React from 'react';

export const CarouselItem: React.VFC<ICarouselItem> = ({
  item,
  inView = false,
  onClick = () => {},
}) =>
  React.cloneElement(item, {
    inView,
    onClick,
    'data-test': 'CarouselItem',
  });

interface ICarouselItem {
  item: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  inView?: boolean;
  onClick?: () => void;
}
